import { render, staticRenderFns } from "./TestDetailsPracticeTest.vue?vue&type=template&id=4f2db7e2"
import script from "./TestDetailsPracticeTest.vue?vue&type=script&lang=js"
export * from "./TestDetailsPracticeTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports